export default {
  "company": "Bedrijf",
  "person": "Contact",
  "invoice": "Factuur",
  api: {
    entity: {
      notFound: "{{entityType}} niet gevonden"
    },
    entityId: {
      notNull: "Er is iets fout gegaan, dit is een onbekende entiteit",
    },
  },
}
